import React from "react";
import { Campaign, Profile } from "../types/model";
import { Modal } from "./Modal";
import PageLoader from "./PageLoader";
import ComponentHeader from "./ComponentHeader";
import { getCampaigns } from "../actions/CMS/campaignActions";
import Select from "react-select";
import ContentDivider from "./ContentDivider";

interface State {
  dropdownOptions: DropdownOption[];
  isLoading: boolean;
  selectedProfile: Profile | null;
  selectedCampaign?: DropdownOption;
  noEmptySubmit: boolean;
  copySuccesfull: boolean;
}

interface Props {
  i18n: any;
  selectedProfile: Profile | null;
  onClose(): void;
}

interface DropdownOption {
  value?: string;
  label: string;
}

class ProfileModalComponent extends React.Component<Props, State> {
  state = {
    dropdownOptions: [],
    isLoading: true,
    selectedProfile: this.props.selectedProfile,
    selectedCampaign: { value: "", label: "" },
    noEmptySubmit: true,
    copySuccesfull: false,
  };

  onSelectChange = (input: any) => {
    this.setState({ selectedCampaign: input });
  };

  onSubmit = () => {
    var campaign = this.state.selectedCampaign;
    if (campaign.value === "") {
      this.setState({ noEmptySubmit: false });
      return;
    }

    this.setState({ noEmptySubmit: true });
    var currentUrl = window.location.origin;
    var profile = this.state.selectedProfile;

    if (campaign != null && profile != null) {
      var campaignUrl = `${currentUrl}/campagne/${campaign.value}/${profile.guid}/1`;
      navigator.clipboard.writeText(campaignUrl);
      this.setState({ copySuccesfull: true });
      this.forceUpdate();
      return;
    }
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    const { selectedProfile } = this.props;
    var campaigns = await getCampaigns();

    var dropdownOptions: DropdownOption[] = campaigns.map((c: Campaign) => {
      return {
        value: c.guid ?? "00000000-0000-0000-0000-000000000000",
        label: c.title,
      };
    });

    this.setState({
      dropdownOptions,
      selectedProfile,
    });

    this.setState({ isLoading: false });
  }

  render() {
    const { dropdownOptions, selectedProfile } = this.state;
    const { i18n } = this.props;

    return (
      <Modal
        width="800px"
        size="medium"
        content={
          this.state.isLoading ? (
            <PageLoader />
          ) : (
            <div className="profileModal">
              <div className="modal-body">
                <ComponentHeader title={`Profiel ${selectedProfile?.id}`} />
                <p className="component-title">{i18n.sendCampaign}</p>
                <div style={{ paddingBottom: 10, paddingTop: 10 }}>
                  <div className="container">
                    <div className={"modal-select-container"}>
                      <Select
                        placeholder={i18n.chooseCampaign}
                        label={this.props.i18n.previousCampaign}
                        options={dropdownOptions}
                        onChange={this.onSelectChange}
                      />
                    </div>
                    <div className="modal-button-container">
                      <button
                        style={{ width: "95%" }}
                        className="whiteButton"
                        onClick={this.onSubmit}
                      >
                        {i18n.copyCampaignLink}
                      </button>
                    </div>
                  </div>
                  <div>
                    {this.state.noEmptySubmit ? (
                      <div />
                    ) : (
                      <p
                        id="selectValidator"
                        className="errorMessage modal-action-message"
                      >
                        {i18n.chooseCampaignValidator}
                      </p>
                    )}
                  </div>
                  <div className="modal-right-align">
                    {!this.state.copySuccesfull ? (
                      <div />
                    ) : (
                      <p className="modal-action-message">
                        {i18n.linkCopiedSuccesfully}
                      </p>
                    )}
                  </div>
                </div>
                <ContentDivider width={"100%"} />
              </div>
              <div className="modal-right-align">
                <button className="whiteButton" onClick={this.props.onClose}>
                  {i18n.close}
                </button>
              </div>
            </div>
          )
        }
      />
    );
  }
}

export default ProfileModalComponent;
